// Legacy docs (mostly Gemini PDF→Doc conversions from 2025) store LaTeX as
// $...$ / $$...$$ plain text, but since the Mathematics extension was
// narrowed to \(...\) / \[...\] (dashboard#6189) they display as raw LaTeX
// source. A dollar-delimited span is only math if it contains a LaTeX
// command (backslash followed by a letter); dollar amounts like "a sample
// $20.00. Those $20.00 include..." never do and must stay literal text.
// Mirrors mobile's normalizeLatexDelimiters (mobile#2899, OPUS-17120).
export const normalizeLatexDelimiters = (html: string): string =>
  html
    .replace(/\$\$([^$<]*\\[a-zA-Z][^$<]*)\$\$/g, "\\[$1\\]")
    .replace(/\$([^$<]*\\[a-zA-Z][^$<]*)\$/g, "\\($1\\)");
